export const homeDescription =
  '읽고 싶은 이야기를 바로 발견하고, 쓰고 싶은 이야기를 바로. 작가와 독자가 망설임 없이 연결되는 웹소설 자유연재 디리토에서 시작하세요.';

export const rankingDescription = '디리토 독자들이 직접 만든 진짜 순위. 지금 가장 많이 읽히는 이야기 모두 여기에 🏆';

export const exploreDescription = '로맨스, 판타지, BL 그 이상. 내 취향의 웹소설, 디리토에서 바로 찾아요 🔍';

export const eventsDescription =
  '작가에게는 도전의 기회, 독자에게는 새로운 발견의 순간. 디리토에서 지금 진행 중인 이벤트와 프로모션을 놓치지 마세요 🎉';

export const searchDescription =
  '제목이 떠오르지 않아도, 작가명이나 장르, 태그 하나만 기억해도 충분해요. 디리토 검색이 나머지를 채워드릴게요 🔎';
